import L from "leaflet";

export const IconLocation = L.icon({
    iconUrl: require("../img/marker.png"),
    iconRetinaUrl: require("../img/marker.png"),
    iconAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [35, 35],
    className: "Leaflet-venue-icon",
});